import {
  Box,
  Button,
  GridItem,
  Image,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  useDisclosure,
  useToast
} from '@chakra-ui/react';
import { useCallback, useEffect, useState } from 'react';

import { CheckImageIcon } from '../../../assets/icons/CheckImageIcon';
import { TrashIcon } from '../../../assets/icons/TrashIcon';
import imageDefaultWomanWithKid from '../../../assets/whiteLabelImage/imageDefault-WomanWithKid.png';
import { sendImageToBucket } from '../../../services/white-label/storage.service';
import { ImageFileUpload } from '../../inputs/ImageFileUpload';
import { ModalCropImage } from '../../widgets/ModalCropImage';

export type ModalImages = {
  src: string;
  path: string;
  alt: string;
};

type ModalSelectImageProps = {
  codigoCorretor?: string;
  isOpenModal: boolean;
  images?: ModalImages[];
  handleModalSelectImage: () => void;
  handleImageSelectedGalleryBanner: (
    currentSelectedImage: any,
    currentSelectedUrlImage: any
  ) => void;
};

const defaultImages = new Array<ModalImages | null>(15)
  .fill(null)
  .map((_, i: number) => ({
    src: imageDefaultWomanWithKid,
    alt: 'image-galery',
    path: `/woman-with-kid-${i + 1}`
  }));

export const ModalSelectImage = ({
  codigoCorretor,
  images,
  isOpenModal,
  handleModalSelectImage,
  handleImageSelectedGalleryBanner
}: ModalSelectImageProps) => {
  const [currentSelectedImagePrev, setCurrentSelectedImagePrev] = useState('');

  const [currentSelectedUrlImagePrev, setCurrentSelectedUrlImagePrev] =
    useState('');

  const [currentSelectedImage, setCurrentSelectedImage] = useState('');

  const [currentSelectedUrlImage, setCurrentSelectedUrlImage] = useState('');

  const [src, setSrc] = useState<any>();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const [imagesContent, setImagesContent] = useState<ModalImages[]>(
    images ?? defaultImages
  );

  useEffect(() => {
    if (images) setImagesContent(images);
  }, [images]);

  const toast = useToast();

  const handleAddImage = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      if (
        (e.target.files[0].type !== 'image/png' &&
          e.target.files[0].type !== 'image/jpeg') ||
        e.target.files[0].size / 1024 ** 2 > 5
      ) {
        e.target.value = '';

        toast({
          position: 'top',
          description:
            'Tamanho superior a 5mb. Ou formato diferente de png/jpeg.',
          status: 'error',
          duration: 4000,
          isClosable: true
        });

        return;
      }

      onOpen();

      const image = URL.createObjectURL(e.target.files[0]);
      setSrc(image);

      // setIsContent([
      //   {
      //     src: src,
      //     alt: e.target.files[0].name,
      //     path: 'local_' + e.target.files[0].name + new Date().toISOString()
      //   },
      //   ...isContent
      // ]);
    }
  };

  const onImageCropped = useCallback(
    async (image: string) => {
      try {
        const pathName = `${codigoCorretor}/img-white-label-${Date.now()}.jpg`;
        const newImage: ModalImages = {
          src: image,
          path: pathName,
          alt: pathName
        };

        await sendImageToBucket({ data: image, pathName });
        setImagesContent((state) => [newImage, ...state]);
      } catch (error) {
        toast({
          title: 'Não foi possível salvar sua imagem',
          description: 'Tente novamente mais tarde.',
          status: 'error'
        });
      }
    },
    [imagesContent, codigoCorretor]
  );

  const handleSubmit = (path: string, src: string) => {
    setCurrentSelectedImage(path);
    setCurrentSelectedUrlImage(src);
    handleModalSelectImage();
  };

  useEffect(() => {
    handleImageSelectedGalleryBanner(
      currentSelectedImage,
      currentSelectedUrlImage
    );
  }, [currentSelectedImage]);

  useEffect(() => {
    setCurrentSelectedImagePrev('');
    setCurrentSelectedUrlImagePrev('');
  }, [handleModalSelectImage]);

  return (
    <>
      <Modal isOpen={isOpenModal} onClose={handleModalSelectImage}>
        <ModalOverlay />
        <ModalContent
          padding="30px"
          width="916px !important"
          height="759px !important"
          maxWidth="none !important"
          borderRadius="24px"
          background="#FFFFFF"
          boxShadow="0px 0px 5px rgba(50, 50, 50, 0.25)"
        >
          <ModalHeader
            fontSize="1.25rem"
            fontWeight="700"
            lineHeight="2rem"
            padding="0px !important"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            Banco de imagens
            <ModalCloseButton
              position="relative"
              top="0px"
              left="0px"
              _hover={{}}
              _focus={{
                '&:focus': {
                  boxShadow: 'none !important'
                }
              }}
              _active={{}}
            />
          </ModalHeader>
          <Box
            borderRadius="14px"
            margin="30px 0"
            border="1px solid #D2D2D2 !important"
            width="856px !important"
            height="559px !important"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Stack
              width="850px !important"
              height="550px !important"
              padding="30px 9px 30px 30px !important"
              display="flex"
              columnGap="26px"
              rowGap="36px"
              direction="row"
              flexFlow="wrap"
              overflow="auto"
              sx={{
                '&::-webkit-scrollbar': {
                  width: '12px'
                },
                '&::-webkit-scrollbar-thumb': {
                  border: '1px solid #FFFFFF',
                  borderRadius: '24px',
                  backgroundColor: '#D9D9D9'
                }
              }}
            >
              <ImageFileUpload
                text="Fazer upload do seu computador"
                inputProps={{
                  onChange: (e) => handleAddImage(e),
                  onClick: (e) => {
                    e.currentTarget.value = '';
                  }
                }}
              />

              {imagesContent
                .filter(
                  (item) =>
                    item != undefined &&
                    item.src !=
                      '/static/media/imageDefault-WomanWithKid.66f41f900ba2026cfa38.png'
                )
                .map((item, index) => {
                  return (
                    <Box
                      key={index}
                      margin="0 !important"
                      cursor="pointer"
                      position="relative"
                      w="180px"
                      h="149px"
                    >
                      <Box
                        margin="0 !important"
                        position="relative"
                        w="180px"
                        h="149px"
                        borderRadius="32px"
                        overflow="hidden"
                        onClick={() => {
                          setCurrentSelectedImagePrev(item.path);
                          setCurrentSelectedUrlImagePrev(item.src);
                        }}
                      >
                        {currentSelectedImagePrev === item.path ? (
                          <Box
                            aria-label="overlay"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            position="absolute"
                            h="100%"
                            w="100%"
                            bg="rgba(0, 0, 0, 0.5)"
                          >
                            <CheckImageIcon w="4.375rem" h="2.875rem" />
                          </Box>
                        ) : null}
                        <Image
                          margin="0 !important"
                          objectFit="cover"
                          src={item.src}
                          alt={item.alt}
                          w="180px"
                          h="148px"
                        />
                        {/* {!item.path.includes('banco') && (
                          <Button
                            w="9px"
                            position="absolute"
                            bottom="0"
                            right="0"
                            bg="transparent"
                            borderRadius="50%"
                            onClick={() => {
                             console.log('tese');
                            }}
                            _hover={{}}
                            _active={{}}
                            _focus={{
                              '&:focus': {
                                boxShadow: 'none !important'
                              }
                            }}
                          >
                            <TrashIcon w="40px" h="30px" />
                          </Button>
                        )} */}
                      </Box>
                    </Box>
                  );
                })}
            </Stack>
          </Box>
          <ModalFooter
            padding="0px !important"
            display="flex"
            justifyContent="space-between"
          >
            <Button
              background="#FFFFFF"
              margin="0px !import"
              width="152px"
              height="48px"
              borderRadius="24px"
              padding="13px 47px"
              gap="10px"
              border="1px solid #001E64"
              onClick={handleModalSelectImage}
              _hover={{}}
              _focus={{
                '&:focus': {
                  boxShadow: 'none !important'
                }
              }}
              _active={{}}
            >
              <Text
                fontSize="1rem"
                lineHeight="1.375rem"
                fontWeight="700"
                color="#001E64"
              >
                Cancelar
              </Text>
            </Button>
            <Button
              background="#FF5000"
              margin="0px !import"
              width="204px"
              height="48px"
              borderRadius="133.5px"
              padding="13px 47px"
              gap="10px"
              onClick={() =>
                handleSubmit(
                  currentSelectedImagePrev,
                  currentSelectedUrlImagePrev
                )
              }
              _hover={{}}
              _focus={{
                '&:focus': {
                  boxShadow: 'none !important'
                }
              }}
              _active={{}}
            >
              <Text
                fontSize="1rem"
                lineHeight="1.375rem"
                fontWeight="700"
                color="#FFFFFF"
              >
                Salvar
              </Text>
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <ModalCropImage
        image={src}
        onImageCropped={onImageCropped}
        //action={imagesContent}
        //setAction={setImagesContent}
        //setSrc={setSrc}
        isOpen={isOpen}
        onClose={onClose}
      />
    </>
  );
};
